import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContentDiv } from "components/containers";
import { StyledButton } from "components/generic";
import { HOME_ROUTE } from "../../utils/constants";
import { NotFoundSection } from "./styles";
import { NavLink } from "react-router-dom";

export const NotFound: FC = () => {
  const { t, i18n } = useTranslation("notfound");

  return (
    <ContentDiv>
      <NotFoundSection>
        <h1>{t("title")}</h1>
        <h2>{t("sub")}</h2>
        <NavLink to={`/${i18n.language}/`} key={HOME_ROUTE}>
          <StyledButton>{t("buttonText")}</StyledButton>
        </NavLink>
      </NotFoundSection>
    </ContentDiv>
  );
};
